import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { map, Observable, switchMap, tap } from 'rxjs';
import { RoleSimulationUser } from '../interfaces/role-simulation';
import { CapabilitiesService } from './capabilities.service';

@Injectable({ providedIn: 'root' })
export class RoleSimulationService {
  
  private http = inject(HttpClient);
  private capabilitiesService = inject(CapabilitiesService);

  private readonly _simulatedUser = signal<RoleSimulationUser | null>(null);
  readonly simulatedUser = this._simulatedUser.asReadonly();

  getUsers(): Observable<RoleSimulationUser[]> {
    return this.http.get<RoleSimulationUser[]>('api/simulazioneruolo/utenti');
  }

  impersonate(user: RoleSimulationUser): Observable<void> {
    return this.http.post<void>(`api/simulazioneruolo/impersonifica/${user.id}`, null).pipe(
      tap(() => this._simulatedUser.set(user)),
      switchMap(() => this.capabilitiesService.load()),
      map(() => undefined),
    );
  }

  terminate(): Observable<void> {
    return this.http.post<void>('api/simulazioneruolo/termina', null).pipe(
      tap(() => this._simulatedUser.set(null)),
      switchMap(() => this.capabilitiesService.load()),
      map(() => undefined),
    );
  }
}
